import classNames from 'classnames'
import React from 'react'
import { getDescMessage } from 'components/FileUploader/helper'
import { ILeftSideDescription } from 'components/FileUploader/interface'
import { useTranslation } from 'react-i18next'
import '../LeftSide.scss'

export const LeftSideDescription = ({
  defaultFileName,
  defaultFileURL,
  errorMessage,
  fileDesc,
  fileName,
  fileTypes,
  isFileAccepted,
  isFileRejected
}: ILeftSideDescription): React.ReactElement | null => {
  const { t } = useTranslation()
  const hasDefaultFile = Boolean(defaultFileURL) && Boolean(defaultFileName)

  const contentClasses: string = classNames('indication-description__content', {
    'indication-description__content--error': errorMessage || isFileRejected,
    'indication-description__content--selected': isFileAccepted || hasDefaultFile
  })

  const desc = getDescMessage({
    defaultFileName,
    defaultFileURL,
    errorMessage,
    fileDesc,
    fileName,
    fileTypes,
    isFileAccepted,
    isFileRejected,
    t
  })

  return <p className={contentClasses}>{desc}</p>
}
